import logoImg from "../../static/images/logo-square.jpg"
import React from "react"
import { useEffect, useState } from "react"
import { IoLocationOutline } from "react-icons/io5"
import { HiBuildingOffice2 } from "react-icons/hi2"
import highlightBars from "../../static/images/highlightBars.svg"
import JobDetail from "./JobDetail"

const App = () => {
    const [jobs, setJobs] = useState([])
    const [activeJob, setActiveJob] = useState(null)
    useEffect(() => {
        fetch("https://backend.ackrobotics.com/api/openJobs")
            .then((res) => {
                if (res.ok) return res.json()
            })
            .then((data) => {
                setJobs(data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    return (
        <div style={{ overflowX: "hidden" }}>
            <div className="jobs-header">
                <a className="footer-company header-company" href="/">
                    <img src={logoImg} alt="logo" className="company-logo" />
                    <h2 className="job-conpany-title">
                        <span className="highlight">ACK</span>
                        <span style={{ fontSize: "10px" }}> </span>Robotics
                    </h2>
                </a>
            </div>
            <div className="job-flex">
                <div className="jobs-container">
                    <div className="jobs-title">
                        <h3 style={{ fontSize: "22px" }}>Currently avilable positions</h3>
                    </div>
                    <hr />
                    {jobs.map((job) => {
                        return (
                            <div key={job._id}>
                                <div className="jobs-item-container">
                                    <h5
                                        className="jobs-item-title"
                                        onClick={() => {
                                            setActiveJob(job)
                                        }}
                                    >
                                        {job.title}
                                    </h5>
                                    <p className="flex-row-center">
                                        <IoLocationOutline /> <span> {job.location}</span>
                                    </p>
                                    <p className="flex-row-center">
                                        <HiBuildingOffice2 /> <span> {job.type}</span>
                                    </p>
                                </div>
                                {/* <div style={{ width: "100%" }}>
                                <div className="line"></div>
                            </div> */}
                            </div>
                        )
                    })}
                </div>
                {activeJob && <JobDetail props={{ ...activeJob, setActiveJob }} />}
            </div>
            <img src={highlightBars} className="highlight-bars" />
        </div>
    )
}

export default App
